/* src/app/components/payroll/corrections/correction-notes-dialog/correction-notes-dialog.component.css */
.error-message {
  color: red;
  font-size: 12px;
  margin-bottom: 4px;
  display: block;
}
.error-message1 {
  color: red;
  font-size: 12px;
}
.field-header {
  font-size: 12px;
}
.ant-form-item {
  margin-bottom: 10px !important;
}
/*# sourceMappingURL=correction-notes-dialog.component-7JOSTA3P.css.map */
